import { PublicClientApplication } from '@azure/msal-browser';
import powerBISettings from './configs/powerBISettings.js';

export const msalConfig = {
  auth: {
    clientId: powerBISettings.UIAppClientId, // App Registration in Azure AD
    authority: "https://login.microsoftonline.com/common", // or 'common' for multi-tenant
    redirectUri: window.location.origin, // your app URL
    postLogoutRedirectUri: powerBISettings.logoutredirectURL // redirect to app root after logout
  },
  cache: {
    cacheLocation: "localStorage", // or "sessionStorage"
    storeAuthStateInCookie: false,
  },
};

// Replace your old endpoints with scopes (resource identifiers)
export const protectedResources = {
  powerBI: {
    endpoint: powerBISettings.reportServiceUrl,
    scopes: [powerBISettings.serviceAppClientId + '/.default'],
  },
  tenantAdmin: {
    endpoint: powerBISettings.tenantAdminServiceUrl,
    scopes: [powerBISettings.serviceAppClientId + '/.default'],
  },
};

export const loginRequest = {
  scopes: ["User.Read"], // Microsoft Graph API example scope
  prompt: "select_account", // This forces Microsoft login UI to appear

};

export const msalInstance = new PublicClientApplication(msalConfig);
